export const IntegrationStatus = () => {
	return (
		<div className="space-y-2">
			<h5 className="text-base font-bold">連携可能な宿泊施設のカテゴリ</h5>
			<div className="bg-bg-layer-100 rounded p-4">
				<div className="space-y-3">
					<div className="flex items-start space-x-3">
						<span className="mt-1.5 h-3 w-3 rounded-full bg-success-400" />
						<div>
							<p className="text-sm font-medium">ホテル</p>
							<p className="text-xs text-zinc-600">連携できます</p>
						</div>
					</div>
					<div className="flex items-start space-x-3">
						<span className="mt-1.5 h-3 w-3 rounded-full bg-yellow-400" />
						<div>
							<p className="text-sm font-medium">民泊</p>
							<p className="text-xs text-zinc-600">連携できません</p>
						</div>
					</div>
					<div className="flex items-start space-x-3">
						<span className="mt-1.5 h-3 w-3 rounded-full bg-error-400" />
						<div>
							<p className="text-sm font-medium">屋外宿泊施設</p>
							<p className="text-xs text-zinc-600">Googleの仕様上連携できません</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
